module.exports = __webpack_public_path__ + "img/Vector4.3c97d1ba.svg";